import { render, staticRenderFns } from "./WrestlerSearchDialog.vue?vue&type=template&id=287f169c&scoped=true"
import script from "./WrestlerSearchDialog.vue?vue&type=script&lang=js"
export * from "./WrestlerSearchDialog.vue?vue&type=script&lang=js"
import style0 from "./WrestlerSearchDialog.vue?vue&type=style&index=0&id=287f169c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f169c",
  null
  
)

export default component.exports